<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Actualizar Foto / Información del Empleado'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="formulario" novalidate class="form-group">

          <div class="row col 12">
            <div [class]="'col-md-11'">
              <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpcionesArea" 
                formControlName="area" [control]="formulario.get('area')" [label]="'Seleccione Area'" [id]="'area'" 
                [habilitar]="chkCmbArea" (change)="getAllEmpleado()">
              </app-lfsa-combo-box>
            </div>
            <div [class]="'col-md-1'">
              <label>Todos</label>
              <br>
              <input type="checkbox" (change)="changeCmbArea()">
            </div>
          </div>

          <div class="row col 12">
            <div [class]="'col-md-11'">
              <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpcionesLocalidad" 
                formControlName="localidad" [control]="formulario.get('localidad')" [label]="'Seleccione Localidad'" [id]="'localidad'" 
                [habilitar]="chkCmbLocalidad" (change)="getAllEmpleado()">
              </app-lfsa-combo-box>
            </div>
            <div [class]="'col-md-1'">
              <label>Todos</label>
              <br>
              <input type="checkbox" (change)="changeCmbLocalidad()">
            </div>
          </div>

          <div class="row col 12">
            <div [class]="'col-md-11'">
              <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpcionesEmpleado"  
                formControlName="empleado" [control]="formulario.get('empleado')" [label]="'Seleccione Empleado'" [id]="'empleado'"
                 [habilitar]="chkCmbEmpleado">
              </app-lfsa-combo-box>
            </div>
            <div [class]="'col-md-1'">
              <label>Todos</label>
              <br>
              <input type="checkbox" (change)="changeCmbEmpleado()">
            </div>
          </div>

          <div class="row col 12">
            <div [class]="'col-md-6'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
                  (click)="updateFotoEmpleado()">Actualizar Foto</button>
              </div>
            </div>

            <div [class]="'col-md-6'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-warning btn-block" [disabled]="formulario.invalid"
                  (click)="updateInfoEmploye()">Actualizar Información</button>
              </div>
            </div>
          </div>

          <div class="row col 12">
            <div [class]="'col-md-6'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
                  (click)="getStatusFotoEmpleado()">Consultar Estado del Proceso</button>
              </div>
            </div>

            <div [class]="'col-md-6'">
              <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
              <div *ngIf="!loading">
                <label>&nbsp;</label><br>
                <button class="btn btn-warning btn-block" [disabled]="formulario.invalid"
                  (click)="getSyncProcess()">Consultar Estado del Proceso</button>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </ng-template>
</div>
<!--
<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-card [innTemplate]="cardActInfo" [titulo]="'Actualizar Información del Empleado'" [efecto]="true" [colapseName]="'cardActInfo'"
    [banderaColapse]='true'></app-card>
  <ng-template #cardActInfo>
    <div [class]="'col-md-3'">
      <label>&nbsp;</label><br>
      <button class="btn btn-success btn-block" (click)="updateInfoEmploye()">Actualizar Información</button>
    </div>
  </ng-template>
</div>
-->
